export function checkForPermission(userPermissions: string[], permission: string) {
    return userPermissions?.includes(permission);
}

export function hasAnyPermission(userPermissions: string[], permissions: string[]) {
    return permissions?.some((permission) => checkForPermission(userPermissions, permission)) ?? false;
}
